import * as React from 'react';
import { IgcNavbarComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A navigation bar component is used to facilitate navigation through
 * a series of hierarchical screens within an app.
 * @slot  - Renders a title inside the default slot.
 * @slot start - Renders left aligned icons.
 * @slot end - Renders right aligned action icons.
 * @csspart base - The base wrapper of the navigation bar.
 * @csspart start - The left aligned icon container.
 * @csspart middle - The navigation bar title container.
 * @csspart end - The right aligned action icons container.
 * @class
 */
export const IgrNavbar = /* @__PURE__ */ createComponent({
  tagName: 'igc-navbar',
  displayName: 'IgrNavbar',
  elementClass: Component,
  react: React,
});

export type IgrNavbar = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrNavbarModule = Component;
